import { Result } from 'journeys/portal/Forms/Sections.constants';
import { paddingLabel } from '../../../HMISection/Data/C11/C11.data';
import { labelWidth } from '../../../HMISection/Data/P710/P710.data';
import { AsFoundResultFormula } from './M66.formulas';

export const AsFoundTestTableSectionDataM66 = (selectedTag, formData) => ({
    rows: [
        {
            key: 1,
            fields: [{
                key: 'As-FoundTest',
                label: 'As-Found Test',
                isLabel: true,
                xs: 12,
                fontWeight: '700',
                padding: '5px 0 0 8px'
            }]
        },
        {
            key: 2,
            fields: [
                {
                    key: 'F430TestMethodTypeUsedLabel',
                    label: 'Test Method Type Used',
                    xs: 4,
                    labelWidth: '98%',
                    padding: '0 0 0 8px',
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                },
                {
                    key: 'F430TestMethodTypeUsed',
                    value: formData.F430TestMethodTypeUsed,
                    isDropdown: true,
                    placeholder: 'Select Test Method Type',
                    options: [{ name: 'Select Test Method Type', value: '' },
                    { name: 'FILTER', value: 'FILTER' },
                    { name: 'MAGNET', value: 'MAGNET' },
                    { name: 'SMOKE GENERATOR', value: 'SMOKE GENERATOR' },
                    { name: 'SMOKE SPRAY', value: 'SMOKE SPRAY' },
                    { name: 'TEST BUTTON', value: 'TEST BUTTON' }],
                    labelWidth: '0',
                    width: '100%',
                    inputTextAlign: 'center',
                    xs: 2,
                    borderBottom: '0',
                }
            ]
        },
        {
            key: 3,
            fields: [
                {
                    key: 'F427AftSmokeDetectorHousingLabel',
                    label: 'Confirm that test method has been applied to smoke detector housing.',
                    xs: 4,
                    labelWidth: '98%',
                    padding: '0 0 0 8px',
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                },
                {
                    key: 'F427AftSmokeDetectorHousing',
                    value: formData.F427AftSmokeDetectorHousing,
                    isRequired: true,
                    isDropdown: true,
                    placeholder: 'Select YES or NO',
                    options: [{ name: 'Select YES or NO', value: '' },
                    { name: 'YES', value: 'YES' },
                    { name: 'NO', value: 'NO' }],
                    labelWidth: '0',
                    width: '100%',
                    inputTextAlign: 'center',
                    xs: 2,
                    borderBottom: '0',
                    height: '2rem',
                    paddingPlaceholder: '5px',
                    arrowMarginTop: '5px'
                }
            ]
        },
        {
            key: 4,
            fields: [
                {
                    key: 'F372AftHmistatus1Label',
                    label: 'HMI Status',
                    xs: 4,
                    labelWidth: '98%',
                    padding: '0 0 0 8px',
                    isLabel: true,
                    fontWeight: '600',
                    fontSize: '9pt',
                },
                {
                    key: 'F372AftHmistatus1',
                    value: formData.F372AftHmistatus1,
                    isRequired: true,
                    isDropdown: true,
                    placeholder: 'Select HMI Status',
                    options: [{ name: 'Select HMI Status', value: '' },
                    { name: 'NORMAL', value: 'NORMAL' },
                    { name: 'ALARM', value: 'ALARM' },
                    { name: 'LOOP FAULT', value: 'LOOP FAULT' }],
                    labelWidth: '0',
                    width: '100%',
                    inputTextAlign: 'center',
                    xs: 2,
                    borderBottom: '0',
                    marginBottom: '0',
                    height: '1.55rem',
                    paddingPlaceholder: '1.5px'
                },
                {
                    key: 'F102AftResultLabel',
                    label: Result.AS_FOUND_RESULT_LABEL,
                    xs: 4,
                    isLabel: true,
                    fontWeight: '700',
                    labelWidth,
                    fontSize: '9pt',
                    textAlign: 'right',
                    padding: paddingLabel,
                },
                {
                    key: 'F102AftResult',
                    value: AsFoundResultFormula(formData),
                    width: '100%',
                    readOnly: true,
                    labelWidth: '0',
                    isCalculatedNew: true,
                    xs: 2,
                    textAlign: 'center',
                    height: '1.3rem',
                    borderRight: '0',
                    borderBottom: '0',
                    direction: 'rtl',
                    marginBottom: '4px',
                    inputMarginRight: '4px',
                    isLabelBold: true,
                    fontWeight: '700'
                }
            ]
        },
    ]
});
